// Lib
import detectNewline from 'detect-newline';

const DEFAULT = '\n';

// Detect the dominant newline character of a string
const getNewLine = (text) => detectNewline(text) || DEFAULT;

export default getNewLine;
